import useTranslation from "./useTranslation";

export default useTranslation;
